/**
 * Pads an EAN to 13 digits so deal alerts and wishlist entries key on one consistent format.
 *
 * Not for structured data: this pads without validating and will happily turn a malformed code into
 * something that looks like a valid GTIN. Markup uses `getGtinProperty`, which checks the length
 * and the check digit and emits nothing when either fails.
 */
export const toEan13 = (ean?: string): string | undefined => {
  if (!ean) return undefined;

  return ean.padStart(13, "0");
};
